import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

/* addons can be either text or jsx */
const FieldWithAddons = (props) => {

	const inputClassNames = classNames({
		[props.input.className || '']: true,
		'form-control': true,
		'is-invalid': props.touched && props.invalidFeedback
	});

	return (
		<div className={`FieldWithAddons ${props.className}`}>
			{props.label && <label>{props.label}</label>}
			<div className="input-group">
				{ props.addonLeftContent &&
					<div className="input-group-prepend">
						<span className='input-group-text'>{props.addonLeftContent}</span>
					</div>
				}

				<input {...props.input} className={inputClassNames} />

				{ props.addonRightContent &&
					<div className="input-group-append">
						<span className='input-group-text'>{props.addonRightContent}</span>
					</div>
				}

			</div>
			{props.touched && props.invalidFeedback &&
				<div>
				{/* kinda hacky, but bootstrap's .invalid-feedback must be a sibling of
				a .form-control.is-invalid but having it inside of an .input-group forces
				it to be inline with the input */}
					<div className='form-control is-invalid d-none'></div>
					<div className='invalid-feedback'>
						{props.invalidFeedback}
					</div>
				</div>
			}
		</div>
	);
};

FieldWithAddons.propTypes = {
	className: PropTypes.string,
	addonLeftContent: PropTypes.node,
	addonRightContent: PropTypes.node,
	touched: PropTypes.bool.isRequired,
	invalidFeedback: PropTypes.string,
	label: PropTypes.string,
	input: PropTypes.shape({
		className: PropTypes.string,
		type: PropTypes.string.isRequired,
		value: PropTypes.any,
		onChange: PropTypes.function,
		onBlur: PropTypes.function,
		id: PropTypes.string
	})
};

export default FieldWithAddons;
